module.exports = __webpack_public_path__ + "static/media/ali-logo.17488a97.png";